import { useState } from "react";
// Persist some state across reloads/refreshes/back button hits
export function usePersistedState(key, initialValue) {
    var _a = useState((localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(key))
        ? JSON.parse(localStorage.getItem(key))
        : initialValue), state = _a[0], setState = _a[1];
    var setPersistedState = function (value) {
        if (value != undefined) {
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(key, JSON.stringify(value));
        }
        else {
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.removeItem(key);
        }
        setState(value);
    };
    return [state, setPersistedState];
}
